module.exports = __webpack_public_path__ + "static/img/labourservices-8.66d9a38.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/rescuelist/img/list/labourservices-8.png
// module id = 4QKh
// module chunks = 1